import React from "react";
import sectionImg from "../../images/Section 05.webp";
import "../../styles/main.scss";

const outcomes = [
  {
    num: "01",
    icon: "📊",
    iconTheme: "navy",
    title: "Your real weekly position, in one clear visual.",
    desc: "You start seeing how the week actually went, how your categories were performing, and whether the salon was moving in a healthy or risky direction. Instead of relying on rough impressions, you get one clear weekly view that makes the business easier to read.",
  },
  {
    num: "02",
    icon: "💸",
    iconTheme: "gold",
    title: "Early detection of leaks and unusual spending patterns.",
    desc: "You begin spotting wastage, unnecessary spending, and unusual cost patterns before they turn into bigger problems. This helps you notice where money may be quietly slipping away — so issues can be addressed earlier instead of being discovered much later.",
  },
  {
    num: "03",
    icon: "🎯",
    iconTheme: "navy",
    title: "Clear weekly direction for what needs attention next.",
    desc: "Each week, you start seeing what deserves attention first, what needs fixing, and what should be watched more carefully in the days ahead. This gives you clearer weekly direction — so the salon can be managed with more awareness, better control, and less guesswork.",
  },
];

const Section05 = () => {
  return (
    <section id="what-you-see" className="section-05">
      <div className="section-05__top-row">
        <div className="section-05__content">
          <h2 className="section-05__title">
            What do you start seeing <br />
            each week inside your salon?
          </h2>

          <p className="section-05__desc">
            Each week, you start seeing your salon more clearly — not through
            guesswork, but through one structured weekly view that helps you
            understand what is really happening inside the business. These are
            the three weekly outcomes salon owners usually find most useful.
          </p>
        </div>

        <div className="section-05__image-wrapper">
          <img
            src={sectionImg}
            alt="Munafa Engine visual report preview"
            className="section-05__image"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>

      <div className="section-05__outcomes">
        {outcomes.map((outcome) => (
          <div className="section-05__outcome-card" key={outcome.num}>
            <div className="section-05__outcome-left">
              <div
                className={`section-05__outcome-icon-circle section-05__outcome-icon-circle--${outcome.iconTheme}`}
              >
                {outcome.icon}
              </div>

              <div
                className={`section-05__outcome-num section-05__outcome-num--${outcome.iconTheme}`}
              >
                {outcome.num}
              </div>
            </div>

            <div className="section-05__outcome-body">
              <h3 className="section-05__outcome-title">
                {outcome.title}
              </h3>

              <p className="section-05__outcome-desc">
                {outcome.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Section05;